import { observable, action } from "mobx";

class TourProduct {
  @observable productId;

  @observable name;

  @observable label;

  @observable tier;

  @observable cost;

  @observable isPaid;

  @observable isSelectable;

  @observable isSelected;

  @observable isBeta;

  constructor({
    productId = null,
    name = null,
    label = null,
    tier = null,
    cost = null,
    isPaid = false,
    isSelectable = true,
    isSelected = false,
    isBeta = false,
  }) {
    this.productId = productId;
    this.name = name;
    this.label = label;
    this.tier = tier;
    this.cost = cost;
    this.isPaid = isPaid;
    this.isSelectable = isSelectable;
    this.isSelected = isSelected;
    this.isBeta = isBeta;
  }

  @action
  setIsSelected(isSelected) {
    this.isSelected = isSelected;
  }
}

export default TourProduct;
